import API_URLS from '../constants/api-urls';
import axios from '../utils/axios';

const cartService = {
    add: (params = {}) => axios.post(`${API_URLS.CART}add`, { ...params }),
    remove: (params = {}, pathParams: PathParams) =>
        axios.delete(`${API_URLS.CART}remove/${pathParams.id}`, { ...params }),
    removeDuplicated: () => axios.get(`${API_URLS.CART}remove-duplicated`)
};

export default cartService;
